import { Pipe, PipeTransform } from '@angular/core';
import { values } from 'lodash';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { elementAt, Observable } from 'rxjs';
import { IndexDatabaseService } from 'src/app/infrastructure/infrastructure-services/common/index-database.service';
import { LoginPageComponent } from 'src/app/login-layout/login-page/login-page.component';

@Pipe({
  name: 'decimalPlaces'
})

export class DecimalPlacesPipe implements PipeTransform {
  constructor(private dbService: NgxIndexedDBService) { }
  storeditems: any;
  transform(value: any, columnName: any): any {
    if (columnName != null && columnName !== "" && value != undefined) {
    //  this.storeditems = this.dbService.getAll('Decimal_Places').subscribe();
     // console.log(this.storeditems, 'get data');
      const storeditemstring = localStorage.getItem('Decimal_Value');
      this.storeditems = storeditemstring ? JSON.parse(storeditemstring) : [];
      this.storeditems.forEach((element: any) => {
        if (columnName in element) {
          value = value.toFixed(element[columnName]);
          return value;
        }
      });
    }
    return value;
  }
}

// <p>{{7 | decimalPlaces :'sumDec'}}</p> 
